export class Entity {
    id : number;
    title: string;
    date: Date;
    modified?: Date;
    status? = "publish";
}
